import { render, staticRenderFns } from "./CollectionPointRegisterPage.vue?vue&type=template&id=4470ac22&scoped=true"
import script from "./CollectionPointRegisterPage.vue?vue&type=script&lang=js"
export * from "./CollectionPointRegisterPage.vue?vue&type=script&lang=js"
import style0 from "./CollectionPointRegisterPage.vue?vue&type=style&index=0&id=4470ac22&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4470ac22",
  null
  
)

export default component.exports